// components/quotatios/form.client.js
'use client';

import { Flex, Input, Select } from 'antd'
import { useEffect, useState } from 'react';
import { isNull } from '@/lib/utils';
import { createClientService } from '@/lib/http/client';
// import { useRouter } from 'nextjs-toploader/app';

export default function QuotatiosForm() {

    // const router = useRouter();

    const [unit, setUnit] = useState([])

    const [quantity, setQuantity] = useState(null);
    const [products, setProducts] = useState(null);
    const [unitId, setUnitId] = useState('config_40');


    useEffect(() => {
        let units = []
        if (typeof window !== 'undefined') {
            units = JSON.parse(localStorage.getItem('unit'));
            if (isNull(units)) {
                // 010801_获取用户单位列表
                createClientService().get('mtop.user.getUserUnitList', {}, { v: '3.0' }).then(res => {
                    localStorage.setItem('unit', JSON.stringify(res.configList));
                    setUnit(res.configList)
                })
            } else {
                setUnit(units)
            }
        }
    }, [])

    const handleSubmit = () => {

        const params = {
            ...(products && { pn: products }),
            ...(quantity && { q: quantity }),
            ...(unitId && { unitId: unitId })
        };

        const queryString = new URLSearchParams(params).toString();
        window.open(`/rfq${queryString ? `?${queryString}` : ''}`, '_blank');
    }


    return (
        <Flex align='center' justify='end' className='quotatios_warp'>
            <div className='quotatios_from'>
                <div className='title'>Want to get quotations?</div>
                <Input placeholder="What are you looking for?" className='from_inp' value={products} onChange={(e) => setProducts(e.target.value)} maxLength={100} />
                <Flex align='center' justify='space-between' className='from_line'>
                    <Input placeholder='Quantity' className='from_inp' value={quantity} onChange={(e) => setQuantity(e.target.value)} />

                    <Select placeholder='Select Country' className='from_select' value={unitId} onChange={(e) => setUnitId(e)}>
                        {
                            unit.map((item, key) => {
                                return <Select.Option key={key} value={item.id}>{item.nameEn}</Select.Option>
                            })
                        }
                        <Select.Option value="1">China</Select.Option>
                    </Select>
                </Flex>
                <Flex align='center' justify='center'>
                    <Flex align='center' justify='center' className='quotatios_btn' onClick={handleSubmit}>Submit</Flex>
                </Flex>
            </div>
        </Flex>

    );
}